import { motion } from 'framer-motion'
import type { ClubStats } from '@/types/api'

interface Props {
  match: ClubStats['latestMatch']
}

export function Scoreboard({ match }: Props) {
  return (
    <section aria-label="Latest match result" className="relative overflow-hidden border-y-2 border-cosmos-green bg-pitch-950 text-white">
      <div className="absolute inset-0 opacity-30 [background:repeating-linear-gradient(45deg,transparent_0_20px,rgba(28,168,74,0.15)_20px_22px)]" />
      <div className="container-narrow py-6 relative">
        <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-6">
          <div className="flex items-center gap-4">
            <div className="grid h-11 w-11 place-items-center rounded-full bg-cosmos-green text-pitch-950 font-display text-sm">
              {match.home.code}
            </div>
            <span className="font-display text-xl md:text-2xl uppercase tracking-wider">{match.home.name}</span>
          </div>

          <motion.div
            className="flex flex-col items-center gap-1"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[10px] tracking-[0.24em] text-cosmos-gold uppercase">Latest · {match.note}</span>
            <div className="flex items-center gap-4 font-display text-3xl md:text-4xl num">
              <span>{match.home.score}</span>
              <span className="text-cosmos-green">–</span>
              <span>{match.away.score}</span>
            </div>
            <span className="rounded bg-cosmos-gold px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-pitch-950">
              {match.status}
            </span>
          </motion.div>

          <div className="flex items-center gap-4 justify-end">
            <span className="font-display text-xl md:text-2xl uppercase tracking-wider">{match.away.name}</span>
            <div className="grid h-11 w-11 place-items-center rounded-full bg-white/15 text-white font-display text-sm">
              {match.away.code}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
